/**
 * @typedef LocationHours
 * @property {boolean} closed - Location closed today
 * @property {?string} end - Close hours (XX:XX)
 * @property {?string} start - Open hours (XX:XX)
 */

/**
 * Parse location hours from Sanity hours string
 * @param {string} val - Location hours
 * @returns {LocationHours}
 * @example
 * parseLocationHours('7:00 AM - 4:30 PM')
 * // => { closed: false, start: '07:00', end: '16:30' }
 * parseLocationHours('Closed')
 * // => { closed: true, start: null, end: null }
 */
const parseLocationHours = val => {
  if (!val || val === 'Closed') {
    return {
      closed: true,
      end: null,
      start: null,
    }
  }

  /**
   * @type {[start: string, end: string]}
   */
  const hoursParts = val
    .toLowerCase()
    .replace(/\s/g, '')
    .split('-')
    .map(time => {
      const period = /am/i.test(time) ? 'am' : 'pm'

      // Remove period
      const cleanTime = time.replace(/[^\d:]/g, '')

      /**
       * @type {[hour: string, minute: string]}
       */
      const timeParts = cleanTime.split(':')

      // Add 12 hours if PM
      const hour = Number(timeParts[0]) + (period === 'pm' ? 12 : 0)

      const formattedTime = [
        hour === 12 ? '00' : `${hour < 10 ? 0 : ''}${hour}`,
        timeParts[1],
      ].join(':')

      return formattedTime
    })

  return {
    closed: false,
    end: hoursParts[1],
    start: hoursParts[0],
  }
}

module.exports = parseLocationHours
